export const camelCaseToPascalCaseWithSpacesHelper = (text) =>
  text
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
    .replace(/\b\w/g, function (match) {
      return match.toUpperCase();
    });
